<div class="tab-pane" role="tabpanel" id="formulario15" style="margin-left: -125px">
    <fieldset id="agregar_formulario15" class="">
        <div class="container" id="center_div">
            <div class="row">
                <div class="col-md-12">
                    <div id='page1' class="contenedorFormulario print-wrap page1">
                        <div>
                            <span style="float: right; clear: right;">(S.A.V.S - 5.1.4 / 6.1.11)</span> Formulario 1.5
                            <span style="float: right; clear: right;">1/3</span>
                        </div>
                        <h1><strong>SOLICITUD DE PERMISO DE OBRA MENOR DE AMPLIACION DE VIVIENDA SOCIAL</strong></h1>
                        <br />
                        <div class="row">
                            <div class="col-md-4">
                                &nbsp;
                            </div>
                            <div class="col-md-4">
                                <h2 class="infObligatorios">
                                    <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                <h2 class="infObligatorios"> {{region}} </h2>
                                <table class="tablaConBorde">
                                    <tr>
                                        <td>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" value="URBANO" [checked]="propiedad[0].ubicacion == 'urbano'" [checked]="propiedad[0].ubicacion == 'URBANO'" />
                                            <label for="tpradio">URBANO</label>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" value="RURAL" [checked]="propiedad[0].ubicacion == 'rural'" [checked]="propiedad[0].ubicacion == 'RURAL'" />
                                            <label for="tpradio">RURAL</label>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-4">
                                <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                    <tbody>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                N&Uacute;MERO SOLICITUD
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                Fecha de Ingreso
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="letraChica">
                                                * A LLENAR POR LA D.O.M
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div>
                            <table style="width: 100%;" class="tablaConBorde table">

                                <tr class="rd_tipo">
                                    <td class="fondoResaltado izquierda" rowspan="2" style="width: 40%">
                                        CERTIFICADO DE INFORMACIONES PREVIAS:
                                    </td>
                                    <td class="fondoResaltado">
                                        N&Uacute;MERO
                                    </td>
                                    <td class="fondoResaltado">
                                        DE FECHA
                                    </td>

                                </tr>
                                <tr class="rd_tipo">
                                    <td>
                                        <input disabled class="form-control" type="text" name="cip" id="cip" [(ngModel)]="cip[0].certcip" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" type="text" name="fecha" id="fecha" [(ngModel)]="cip[0].fecha_cip" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                <span class="help-block"></span>
                            </div>
                            <table style="width: 100%" border="0" class="tablaConBorde table">
                                <tr class="fondoResaltado">
                                    <td style="width: 57%" colspan="3">
                                        CALLE O CAMINO
                                    </td>
                                    <td style="width: 24%">
                                        N&Uacute;MERO
                                    </td>
                                    <td style="width: 19%">
                                        ROL SII
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                    </td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td style="width: 11%">
                                        MANZANA
                                    </td>
                                    <td style="width: 10%">
                                        LOTE
                                    </td>
                                    <td style="width: 61%" colspan="2">
                                        LOTEO O LOCALIDAD
                                    </td>
                                    <td style="width: 18%">
                                        PLANO DE LOTEO N°
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].loteo" />
                                    </td>
                                    <td colspan="2">
                                        <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].plano" />
                                    </td>
                                </tr>
                            </table>

                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>2.- DECLARACION JURADA</span>
                                <span class="help-block"></span>
                            </div>

                            <table style="width: 100%;" class="tablaConBordeExterno table">
                                <tr>
                                    <td colspan="7"><input disabled class="form-control" id="nombre" name="nombre" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                    <td align="right" colspan="4"><span>C&Eacute;DULA DE</span></td>

                                </tr>
                                <tr>
                                    <td align="left"><span>IDENTIDAD Nº</span></td>
                                    <td colspan="5"><input disabled class="form-control" id="rut" name="rut" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                    <td colspan="5" align="right"><span>DECLARA BAJO SU RESPONSABILIDAD</span></td>
                                </tr>
                                <tr>
                                    <td align="left"><span> SER</span></td>
                                    <td align="left"><span>PROPIETARIO</span></td>
                                    <td colspan="3" align="center"><span>(O  REPRESENTANTE  LEGAL  DEL  PROPIETARIO)</span> </td>
                                    <td colspan="2"><span>DEL  BIEN  RAIZ</span></td>
                                    <td align="left" colspan="4"><span>UBICADO  EN  CALLE/ </span></td>
                                </tr>
                                <tr>
                                    <td align="left"><span>/AVENIDA/CAMINO</span></td>
                                    <td align="right" colspan="3"><input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propietarios[0].direccion" /></td>
                                    <td align="left" colspan="3"><span>NUMERO:</span> </td>
                                    <td align="left" colspan="4"><input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propietarios[0].direccion_num" /></td>
                                </tr>
                                <tr>
                                    <td align="left"><span>ROL DE AVALUO Nº</span></td>
                                    <td align="right" colspan="2"><input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" /></td>
                                    <td align="left"> <span>DE LA COMUNA DE </span></td>
                                    <td align="right" colspan="7"><input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" /></td>
                                </tr>
                                <tr>
                                    <td colspan="2" align="left"><span>QUE SE ENCUENTRA INSCRITO A FOJAS</span></td>
                                    <td align="right"><input disabled class="form-control" id="inscripcion" name="inscripcion" type="text" [(ngModel)]="registro_bienes[0].inscrito" /></td>
                                    <td align="center"><span>N°</span></td>
                                    <td align="right" colspan="2"><input disabled class="form-control" id="num_insc" name="num_insc" type="text" [(ngModel)]="registro_bienes[0].numero" /></td>
                                    <td align="center"><span>AÑO</span></td>
                                    <td align="right"><input disabled class="form-control" id="anio_insc" name="anio_insc" type="text" [(ngModel)]="registro_bienes[0].anio" /></td>
                                    <td colspan="3" align="left"><span>DEL REGISTRO</span></td>
                                </tr>
                                <tr>
                                    <td align="left">DE PROPIEDAD</td>
                                    <td colspan="2" align="left"> DEL CONSERVADOR</td>
                                    <td align="left"> DE BIENES </td>
                                    <td align="left"> RAÍCES DE</td>
                                    <td align="left" colspan="6"><input disabled class="form-control" id="raices" name="raices" type="text" [(ngModel)]="registro_bienes[0].bienes" /></td>

                                </tr>
                                <tr>
                                    <td align="left">EN EL CUAL</td>
                                    <td align="left">SE EMPLAZA</td>
                                    <td colspan="2" align="left"><span>EL PROYECTO</span></td>
                                    <td align="left"><span>PARA EL QUE SE</span></td>
                                    <td colspan="6" align="left"><span>PRESENTA ESTA SOLICITUD</span></td>

                                </tr>

                            </table>

                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>3.- DATOS DEL PROPIETARIO</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group clone1">
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        NOMBRE DEL PROPIETARIO
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                    <td>
                                        FIRMA DEL PROPIETARIO
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                    </td>
                                    <td rowspan="7">

                                    </td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        REPRESENTANTE LEGAL
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="representantes[0].nombre" /></td>
                                    <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="representantes[0].rut" /></td>
                                </tr>

                                <tr class="fondoResaltado">
                                    <td style="width: 25%">
                                        DIRECCI&Oacute;N / CALLE / PASAJE
                                    </td>
                                    <td style="width: 25%">
                                        N°
                                    </td>
                                    <td style="width: 25%">
                                        COMUNA
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td>
                                        E-MAIL
                                    </td>
                                    <td>
                                        TEL&Eacute;FONO
                                    </td>
                                    <td>
                                        FAX
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado tablaConBordeExterno table">
                                    <td colspan="4">
                                        PERSONERIA DEL REPRESENTANTE LEGAL
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        SE ACREDITA MEDIANTE
                                    </td>
                                    <td colspan="3">
                                        <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        DE FECHA
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                    </td>
                                    <td>
                                        Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        ANTE EL NOTARIO SR(A)
                                    </td>
                                    <td colspan="3">
                                        <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>4.- ARQUITECTO PROYECTISTA</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group clone1">
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%"><span>
                                        NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica">(cuando corresponda)</span>
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                    <td>
                                        FIRMA
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                    </td>
                                    <td rowspan="5"></td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        NOMBRE ARQUITECTO PROYECTISTA
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                    <td><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                </tr>

                                <tr class="fondoResaltado">
                                    <td style="width: 25%">
                                        DIRECCI&Oacute;N / CALLE / PASAJE
                                    </td>
                                    <td style="width: 25%">
                                        N°
                                    </td>
                                    <td style="width: 25%">
                                        COMUNA
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td>
                                        E-MAIL
                                    </td>
                                    <td>
                                        TEL&Eacute;FONO
                                    </td>
                                    <td>
                                        FAX
                                    </td>
                                    <td>
                                        PATENTE PROFESIONAL N°
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                    <div id='page2' class="contenedorFormulario print-wrap page2">
                        <div>
                            <span style="float: right; clear: right;">(S.A.V.S - 5.1.4 / 6.1.11)</span> Formulario 1.5
                            <span style="float: right; clear: right;">2/3</span>
                        </div>
                        <br />
                        <div>
                            <div class="tituloSeccion">
                                <span>5.- CONSTRUCTOR</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%"><span>
                                            NOMBRE O RAZON SOCIAL DE LA EMPRESA CONSTRUCTORA</span>
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                    <td>
                                        FIRMA
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <input disabled class="form-control" readonly id="nombre_constra" name="nombre_constra" type="text" [(ngModel)]="constructora[0].nombre" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rut_constra" name="rut_constra" type="text" [(ngModel)]="constructora[0].rut" />
                                    </td>
                                    <td rowspan="5"></td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        NOMBRE DEL CONSTRUCTOR *
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="nombre_const" name="nombre_const" type="text" [(ngModel)]="constructores[0].nombre" /></td>
                                    <td><input disabled class="form-control" id="rut_const" name="rut_const" type="text" [(ngModel)]="constructores[0].rut" /></td>
                                </tr>

                                <tr class="fondoResaltado">
                                    <td style="width: 25%">
                                        DIRECCI&Oacute;N / CALLE / PASAJE
                                    </td>
                                    <td style="width: 25%">
                                        N°
                                    </td>
                                    <td style="width: 25%">
                                        COMUNA
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="constructores[0].direccion" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="constructores[0].direccion_num" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="constructores[0].comuna" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td>
                                        E-MAIL
                                    </td>
                                    <td>
                                        TEL&Eacute;FONO
                                    </td>
                                    <td>
                                        FAX
                                    </td>
                                    <td>
                                        PATENTE PROFESIONAL N°
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="email_const" name="email_const" type="email" [(ngModel)]="constructores[0].mail" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="tel_const" name="tel_const" type="text" [(ngModel)]="constructores[0].fono" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fax_const" name="fax_const" type="text" [(ngModel)]="constructores[0].fax" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="pat_const" name="pat_const" type="text" [(ngModel)]="constructora[0].patente" />
                                    </td>
                                </tr>
                            </table>
                            <div class="letraChica"><span>* Profesional que podr&aacute; individualizarse hasta antes del inicio de las obras</span></div>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>6.- ANTECEDENTES DE PERMISOS Y RECEPCIONES ANTERIORES DE LA VIVIENDA SOCIAL QUE SE AMPLIA</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td style="width: 25%">PERMISO PRIMITIVO</td>
                                    <td style="width: 25%">N°</td>
                                    <td style="width: 25%">FECHA</td>
                                    <td style="width: 25%">SUPERFICIE M2</td>
                                </tr>
                                <tr *ngFor="let prim of perm_pri; let i of index">
                                    <td><input disabled class="form-control" readonly id="permiso_prim" name="permiso_prim" type="text" [(ngModel)]="prim.permiso" /></td>
                                    <td><input disabled class="form-control" readonly id="permiso_num" name="permiso_num" type="text" [(ngModel)]="prim.numero" /></td>
                                    <td><input disabled class="form-control" readonly id="permiso_fecha" name="permiso_fecha" type="text" [(ngModel)]="prim.fecha" /></td>
                                    <td><input disabled class="form-control" readonly id="superficie" name="superficie" type="text" [(ngModel)]="prim.superficie" /></td>
                                </tr>
                            </table>
                            <br />
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td style="width: 25%">AMPLIACIONES</td>
                                    <td style="width: 25%">N°</td>
                                    <td style="width: 25%">FECHA</td>
                                    <td style="width: 25%">SUPERFICIE M2</td>
                                </tr>
                                <tr *ngFor="let ampl of ampliaciones ; let i of index">
                                    <td><input disabled class="form-control" readonly id="modif_prim1" name="modif_prim1" type="text" [(ngModel)]="ampl.permiso" /></td>
                                    <td><input disabled class="form-control" readonly id="modif_num1" name="modif_num1" type="text" [(ngModel)]="ampl.numero" /></td>
                                    <td><input disabled class="form-control" readonly id="modif_fecha1" name="modif_fecha1" type="text" [(ngModel)]="ampl.fecha" /></td>
                                    <td><input disabled class="form-control" readonly id="modif_sup1" name="modif_sup1" type="text" [(ngModel)]="ampl.superficie" /></td>
                                </tr>
                            </table>
                            <br />
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td style="width: 25%">RECEPCION</td>
                                    <td style="width: 25%">N°</td>
                                    <td style="width: 25%">FECHA</td>
                                    <td style="width: 25%">SUPERFICIE M2</td>
                                </tr>
                                <tr *ngFor="let rec of recep; let i of index">
                                    <td><input disabled class="form-control" readonly id="recep_prim1" name="recep_prim1" type="text" [(ngModel)]="rec.permiso" /></td>
                                    <td><input disabled class="form-control" readonly id="recep_num1" name="recep_num1" type="text" [(ngModel)]="rec.numero" /></td>
                                    <td><input disabled class="form-control" readonly id="recep_fecha1" name="recep_fecha1" type="text" [(ngModel)]="rec.fecha" /></td>
                                    <td><input disabled class="form-control" readonly id="recep_sup1" name="recep_sup1" type="text" [(ngModel)]="rec.superficie" /></td>
                                </tr>
                            </table>

                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>7.- ANTECEDENTES DE LA AMPLIACI&Oacute;N</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado">SUPERFICIE VIVIENDA EXISTENTE CON PERMISO Y RECEPCION DEFINITIVA (m2)</td>
                                    <td><input disabled class="form-control" readonly id="superf_exist" name="superf_exist" type="text" [(ngModel)]="ampliacion[0].sup_permiso" /></td>
                                    <td class="fondoResaltado">SUPERFICIE TERRENO (m2)</td>
                                    <td><input disabled class="form-control" readonly id="superf_terren" name="superf_terren" type="text" [(ngModel)]="ampliacion[0].superf_terreno" /></td>
                                </tr>
                            </table>
                            <br />
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td rowspan="2" colspan="2" class="tablaConBorde Externo table fondoResaltado" style="width: 20%"></td>
                                    <td colspan="4" style="width: 60%">SUPERFICIE EDIFICADA</td>
                                    <td colspan="6" rowspan="2" style="width: 20%">SUPERFICIE AMPLIACION</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="fondoResaltado" style="width: 30%">EXISTENTE</td>
                                    <td colspan="2" class="fondoResaltado" style="width: 30%"> AMPLIACION</td>

                                </tr>
                                <tr>
                                    <td colspan="2">1er Piso</td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="piso1_ex" name="piso1_ex" type="text" [(ngModel)]="ampliacion[0].piso1_ex" /></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="piso1_amp" name="piso1_amp" type="text" [(ngModel)]="ampliacion[0].piso1_amp" /></td>
                                    <td colspan="6" rowspan="3"><input disabled class="form-control" readonly id="sup_ampl" name="sup_ampl" type="textarea" [(ngModel)]="ampliacion[0].superf_amp" /></td>
                                </tr>
                                <tr>
                                    <td colspan="2">2do Piso</td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="piso2_ex" name="piso2_ex" type="text" [(ngModel)]="ampliacion[0].piso2_ex" /></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="piso2_amp" name="piso2_amp" type="text" [(ngModel)]="ampliacion[0].piso2_amp" /></td>
                                </tr>
                                <tr>
                                    <td colspan="2">3er Piso</td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="piso3_ex" name="piso3_ex" type="text" [(ngModel)]="ampliacion[0].piso3_ex" /></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="piso3_amp" name="piso3_amp" type="text" [(ngModel)]="ampliacion[0].piso3_amp" /></td>
                                </tr>
                            </table>
                            <br />
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td colspan="8" class="fondoResaltado izquierda">LA VIVIENDA SOCIAL FORMA PARTE DE UN CONDOMINIO (Ley 19.537)</td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="viv_cond" name="viv_cond" value="SI" [checked]="ampliacion[0].condominio == 'SI'" />
                                        <span>SI</span></td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="viv_cond" name="viv_cond" value="NO" [checked]="ampliacion[0].condominio == 'NO'" />
                                        <span>NO</span></td>
                                </tr>
                                <tr>
                                    <td colspan="8" class="fondoResaltado izquierda">LA VIVIENDA QUE SE AMPLIA MANTIENE SU CONDICION DE VIVIENDA ECONOMICA (hasta 140 m2)</td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="viv_econ" name="viv_econ" value="SI" [checked]="ampliacion[0].economica == 'SI'" />
                                        <span>SI</span></td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="viv_econ" name="viv_econ" value="NO" [checked]="ampliacion[0].economica == 'NO'" />
                                        <span>NO</span></td>
                                </tr>
                            </table>

                        </div>

                        <div>
                            <div class="tituloSeccion">
                                <span>8.- ANTECEDENTES QUE SE ADJUNTAN</span>
                                <span class="help-block"></span>
                                <span class="letraChica">(ART. 5.1.4 N° 2 y 6.1.11 O.G.U.C.)</span>
                            </div>

                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td style="width: 5%">DOM</td>
                                    <td colspan="2" style="width: 40%"></td>
                                    <td style="width: 5%">DOM</td>
                                    <td colspan="2" style="width: 40%"></td>
                                </tr>
                                <tr>
                                    <td style="width: 5%"></td>
                                    <td align="center" style="width: 5%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td style="width: 40%"><span>Listado de documentos y planos numerados</span></td>
                                    <td style="width: 5%"></td>
                                    <td align="center" style="width: 5%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td style="width: 40%"><span>Planos de planta general y elevaciones, a escala 1:50, con las cotas minimas indispensables con indivisualizacion de los recintos y cuadros de superficie</span></td>
                                </tr>
                                <tr>
                                    <td style="width: 5%"></td>
                                    <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td><span>Fotocopia Certificado de Informaciones Previas Vigente</span></td>
                                    <td style="width: 5%"></td>
                                    <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td><span>Croquis de emplazamiento, a escala, en que se grafique la edificaci&oacute;n existente y la ampliaci&oacute;n</span></td>
                                </tr>
                                <tr>
                                    <td style="width: 5%"></td>
                                    <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td><span>Fotocopia de Patente al dia del o los Profesional (es)Competente(s)</span></td>
                                    <td style="width: 5%"></td>
                                    <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td><span>Especificaciones Tecnicas resumidas, por partidas</span></td>
                                </tr>
                                <tr>
                                    <td style="width: 5%"></td>
                                    <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td><span>Encuesta de Edificación INE</span></td>
                                    <td style="width: 5%" rowspan="2"></td>
                                    <td align="center" rowspan="2"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td rowspan="2"><span> Informe del arquitecto que certifique que la ampliacion cumple con las normas tecnicas de habilidad y seguridad, con las normas tecnicas de estabilidad y con las instalaciones interiores de electricidad y cuando corresponda, de agua potable, alcantarillado y gas establecidas por los organismos competentes.</span></td>
                                </tr>
                                <tr>
                                    <td style="width: 5%"></td>
                                    <td align="center"><input type="checkbox" class="form-check-inline" s id="documentos" name="documentos" /></td>
                                    <td><span>Acuerdo de los Copropietarios en caso de que la vivienda que se amplia, se emplace en un condominio (cuando corresponda)</span></td>
                                </tr>
                            </table>


                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>9.- DERECHOS MUNICIPALES </span><span class="letraChica"> (A LLENAR POR LA D.O.M)</span>
                                <span class="help-block"></span>
                            </div>

                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td colspan="3" class="fondoResaltado izquierda">PRESUPUESTO DE OBRA</td>
                                    <td colspan="3"> <input disabled class="form-control" readonly id="presupuesto" name="presupuesto" type="text" value="$" /></td>
                                    <td colspan="3" class="fondoResaltado izquierda">MONTO DERECHOS MUNICIPALES</td>
                                    <td colspan="3"> <input disabled class="form-control" readonly id="monto" name="monto" type="text" value="$" /></td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="fondoResaltado izquierda">PORCENTAJE A CONSIGNAR</td>
                                    <td align="right" colspan="3"><input disabled class="form-control" readonly id="giro" name="giro" type="text" value="%" /></td>
                                    <td colspan="3" class="fondoResaltado izquierda"></td>
                                    <td colspan="3"><input disabled class="form-control" readonly id="giro" name="giro" type="text" value="$" /></td>
                                </tr>
                                <tr>
                                    <td colspan="10" class="fondoResaltado izquierda">REBAJA DERECHOS MUNICIPALES <span class="letraChica">(a la menos 50%)</span></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="rebaja" name="rebaja" type="text" value="$" /></td>
                                </tr>
                                <tr>
                                    <td colspan="10" class="fondoResaltado izquierda">MONTO A PAGAR DERECHOS MUNICIPALES <span class="letraChica">(a la menos 50%)</span></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="total" name="total" type="text" value="$" /></td>
                                </tr>
                                <tr>
                                    <td colspan="3" class="fondoResaltado izquierda">GIRO INGRESO MUNICIPAL N°</td>
                                    <td colspan="3"> <input disabled class="form-control" readonly id="num_giro" name="num_giro" type="text" /></td>
                                    <td colspan="3" class="fondoResaltado izquierda">DE FECHA</td>
                                    <td colspan="3"> <input disabled class="form-control" readonly id="fech_giro" name="fech_giro" type="text" /></td>
                                </tr>
                            </table>
                            <br />
                            <br />
                            <br />
                            <br />

                        </div>
                    </div>
                    <div id='page3' class="contenedorFormulario print-wrap page3">
                        <div>
                            <span style="float: right; clear: right;">(S.A.V.S - 5.1.4 / 6.1.11)</span> Formulario 1.5
                            <span style="float: right; clear: right;">3/3</span>
                        </div>
                        <br />
                        <div class="tablaConBordeExterno">
                            <span>NOTA </span><span class="letraChica">( PARA SITUACIONES ESPECIALES )</span>
                            <span><input disabled class="form-control" readonly id="nota" name="nota" type="textarea" /></span>
                        </div>
                        <div>
                            <br />
                            <br />
                            <br />
                            <hr />
                            <br />
                            <br />
                        </div>
                        <div>
                            <div><span style="float: right; clear: right;">(S.A.V.S - 5.1.4 / 6.1.11)</span></div>
                            <div>
                                <h1><strong>COMPROBANTE DE INGRESO</strong></h1>
                            </div>
                        </div>
                        <br />
                        <br />
                        <div>
                            <table class="tablaConBorde izquierda">
                                <tr>
                                    <td class="fondoResaltado">MONTO CONSIGNADO AL INGRESO</td>
                                    <td><input disabled class="form-control" readonly id="monto" name="monto" type="text" value="$" /></td>
                                    <td class="fondoResaltado">GIM N°</td>
                                    <td><input disabled class="form-control" readonly id="gim" name="gim" type="text" /></td>
                                    <td class="fondoResaltado">FECHA</td>
                                    <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" /></td>
                                </tr>
                            </table>
                        </div>
                        <br />
                        <div class="row">
                            <div class="col-md-4">
                                <table class="tablaConBordeExterno">
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr align="center">
                                        <td>FIRMA FUNCIONARIO.</td>
                                    </tr>
                                    <tr align="center">
                                        <td> Y TIMBRE D.O.M.</td>
                                    </tr>

                                </table>

                            </div>
                            <br />
                            <div class="col-md-4">
                                <h2 class="infObligatorios">
                                    <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                <h2 class="infObligatorios"> {{region}} </h2>
                            </div>
                            <div class="col-md-4">
                                <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                    <tbody>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                N&Uacute;MERO SOLICITUD
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                Fecha de Ingreso
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        <br />
                        <div>
                            <table class="tablaConBorde">
                                <tr class="fondoResaltado">
                                    <td>CALLE O CAMINO</td>
                                    <td>N&Uacute;MERO</td>
                                </tr>
                                <tr>
                                    <td><input class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                    <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                </tr>
                            </table>
                        </div>
                        <hr />
                        <br />
                        <br /><br /><br /><br />
                    </div>
                </div>
            </div>
        </div>
        <div>
            <button mat-raised-button color="primary" id="pdf-download-link" title="Descargar Formulario 1.5" (click)="captureScreen()">Descargar Formulario 1.5</button>
        </div>
    </fieldset>
</div>